// 番外篇图片清单 - 由 npm run update-extra-photos 自动生成
import { toImageAssets, type ImageAsset } from '../types/imageAsset';

export type ExtraPhotoManifestEntry = {
  photos: ImageAsset[];
  messagePhotos: ImageAsset[];
};

const RAW_EXTRA_PHOTO_MANIFEST: Record<string, { photos: string[]; messagePhotos: string[] }> = {
  "G1/G1-1": {
    "photos": [],
    "messagePhotos": []
  },
  "G1/G1-2": {
    "photos": [],
    "messagePhotos": []
  },
  "G2/G2-1": {
    "photos": [],
    "messagePhotos": []
  },
  "G2/G2-2": {
    "photos": [],
    "messagePhotos": []
  },
  "G3/G3-1": {
    "photos": [],
    "messagePhotos": []
  }
};

export const EXTRA_PHOTO_MANIFEST: Record<string, ExtraPhotoManifestEntry> = Object.fromEntries(
  Object.entries(RAW_EXTRA_PHOTO_MANIFEST).map(([folder, entry]) => [
    folder,
    {
      photos: toImageAssets(entry.photos),
      messagePhotos: toImageAssets(entry.messagePhotos)
    }
  ])
);
